import {
    ADD_CONTEXT_PROPERTY,
    REMOVE_CONTEXT_PROPERTY,
    SET_CONTEXT_PROPERTIES,
    UPDATE_CONTEXT_PROPERTY
} from "../actions/contextPropertiesActions";

export default function (state = [], action) {
    switch (action.type) {
        case ADD_CONTEXT_PROPERTY:
            return [...state, action.contextProperty];
        case REMOVE_CONTEXT_PROPERTY:
            return state.filter((contextProperty) => contextProperty.name !== action.contextProperty.name);
        case SET_CONTEXT_PROPERTIES:
            return action.contextProperties;
        case UPDATE_CONTEXT_PROPERTY:
            return [...state.map((contextProp) => {
                if (action.name === contextProp.name) {
                    contextProp = {...contextProp, [action.property]: action.value};
                    return contextProp;
                }
                return contextProp;
            })];
        default:
            return state;
    }

}